<template>
    <v-app id="path-viewer-extended-toolbar">
        <Header />
        <v-main class="pt-10 mb-10">
            <v-container class="mainTitle d-inline-flex justify-center">
                <div class="text-h1-title">{{ $t('chooseSolution.configYourSolution') }}</div>
            </v-container>
            
            <v-container class="subTitle d-inline-flex justify-center">
                <i18n path="chooseSolution.configYourSolution_subtitle" tag="div" class="text-subtitle">
                    <br />
                </i18n>

            </v-container>

            <v-container class="sectionTitle d-inline-flex justify-center my-10">
                <div class="text-h6-title">{{ $t('chooseSolution.selectWaterproofingType') }}</div>
            </v-container>

            <v-container class="solutionContainer d-inline-flex justify-center">
                <v-card v-for="(item, i) in solutions" :key="i" tile elevation="0" height="220" width="240" class="solutionCard mx-4" @click="goTo(item.linkComponent, item.wPathInit, item.wQuestionsInit)">
                    <v-card-text>
                        <div class="solution-img" :class="item.classCssItem"></div>
                        <div class="solutionSubtitle">{{item.subtitle}}</div>
                        <div class="solutionTitle">{{item.title}}</div>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-main>
        <Footer />
    </v-app>
</template>

<script>
import Header from "./Header"
import Footer from "./Footer"

export default {
    components: { Header, Footer },

    computed:{
        solutions(){
            return [
                { 
                    title: this.$i18n.t('chooseSolution.bitumenMembranes_title'), 
                    subtitle: this.$t('chooseSolution.bitumenMembranes_subtitle'), 
                    classCssItem: 'membraneBituminose', 
                    linkComponent: 'PathViewer',
                    wPathInit: "0a",
                    // wQuestionsInit: {"text":"Scelta della copertura","wPath":["0a"]}
                    wQuestionsInit: {"text":"Tipologia di impermeabilizzazione","wPath":[]}
                },
                { 
                    title: 'manti sintetici', 
                    subtitle: 'Impermeabilizzazione con', 
                    classCssItem: 'mantiSintetici', 
                    linkComponent: 'PathViewer' ,
                    wPathInit: "01",
                    wQuestionsInit: {"text":"Tipologia di impermeabilizzazione","wPath":[]}
                }
            ]
        }
    },

    data(){
        return {
        }
    },

    methods:{
        goTo(link, wPathInit, wQuestionsInit){
            this.$router.push({ 
                name: link,
                params : {
                    wPathInit: wPathInit,
                    wQuestionsInit: wQuestionsInit
                }
            })
        }
    }

}
</script>

<style>
#path-viewer-extended-toolbar{
    font-family: 'Montserrat' !important;
    background: #efefef;
}
.mainTitle .text-h1-title{
    font-size: 40px !important;
    font-weight: 300;
    color: #404040;
    border-bottom: 1px solid #404040;
}
.subTitle .text-subtitle{
    font-size: 15px !important;
    font-weight: 300;
    color: #404040;
    line-height: 17px;
}
.sectionTitle .text-h6-title{
    font-size: 24px !important;
    font-weight: 800;
    color: #404040;
    text-transform: uppercase;
}

.solutionContainer .solutionCard{
    border-radius: 4px !important;
    cursor: pointer;
}
.solution-img{
    width: 95px;
    height: 95px;
    margin: 0 auto;
    margin-top: 30px;
}
.solutionContainer .solutionSubtitle{
    font-size: 14px;
    font-weight: 300;
    color: #404040;
}
.solutionContainer .solutionTitle{
    font-size: 14px;
    font-weight: 800;
    color: #0c5a61;
    text-transform: uppercase;
}

.solutionContainer .solutionCard:hover{
    background-color: #0c5a61;
    color: #ffffff !important;
}
.solutionContainer .solutionCard:hover .solutionSubtitle,
.solutionContainer .solutionCard:hover .solutionTitle{
    color: #ffffff;
}


.solutionContainer .solutionCard .membraneBituminose{
    background: url(../assets/polyglass_mebrana_bituminosa.png) no-repeat;
}
.solutionContainer .solutionCard:hover .membraneBituminose{
    background: url(../assets/polyglass_mebrana_bituminosa_hover.png) no-repeat;
}

.solutionContainer .solutionCard .mantiSintetici{
    background: url(../assets/polyglass_manto_sintetico.png) no-repeat;
}
.solutionContainer .solutionCard:hover .mantiSintetici{
    background: url(../assets/polyglass_manto_sintetico_hover.png) no-repeat;
}


</style>


// WEBPACK FOOTER //
// src/components/ChooseSolution.vue